var _linearGradient, _path, _linearGradient2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "WWZG4nXidbdKz8SNbGF5Za",
    x1: 6.414,
    x2: 41.774,
    y1: 13.662,
    y2: 39.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#28afea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047ed6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#WWZG4nXidbdKz8SNbGF5Za)",
    d: "M6,40V12h36v28c0,1.1-0.9,2-2,2H8C6.9,42,6,41.1,6,40z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "WWZG4nXidbdKz8SNbGF5Zb",
    x1: 6.42,
    x2: 41.198,
    y1: 6.608,
    y2: 13.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0077d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b59a2"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#WWZG4nXidbdKz8SNbGF5Zb)",
    d: "M42,8v6H6V8c0-1.1,0.9-2,2-2h32C41.1,6,42,6.9,42,8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5,12.5L35.5,12.5c-1.657,0-3-1.343-3-3V6h6v3.5C38.5,11.157,37.157,12.5,35.5,12.5z",
    opacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5,11.75L35.5,11.75c-1.243,0-2.25-1.007-2.25-2.25V6h4.5v3.5C37.75,10.743,36.743,11.75,35.5,11.75z",
    opacity: 0.07
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5,12.5L12.5,12.5c-1.657,0-3-1.343-3-3V6h6v3.5C15.5,11.157,14.157,12.5,12.5,12.5z",
    opacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5,11.75L12.5,11.75c-1.243,0-2.25-1.007-2.25-2.25V6h4.5v3.5C14.75,10.743,13.743,11.75,12.5,11.75z",
    opacity: 0.07
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#3ccbf4",
    d: "M12.5,11L12.5,11c-0.828,0-1.5-0.672-1.5-1.5v-4C11,4.672,11.672,4,12.5,4h0C13.328,4,14,4.672,14,5.5v4C14,10.328,13.328,11,12.5,11z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38,19.5v3c0,0.276-0.224,0.5-0.5,0.5h-3c-0.276,0-0.5-0.224-0.5-0.5v-3c0-0.276,0.224-0.5,0.5-0.5h3C37.776,19,38,19.224,38,19.5z M30,19.5v3c0,0.276-0.224,0.5-0.5,0.5h-3c-0.276,0-0.5-0.224-0.5-0.5v-3c0-0.276,0.224-0.5,0.5-0.5h3C29.776,19,30,19.224,30,19.5z M22,19.5v3c0,0.276-0.224,0.5-0.5,0.5h-3c-0.276,0-0.5-0.224-0.5-0.5v-3c0-0.276,0.224-0.5,0.5-0.5h3C21.776,19,22,19.224,22,19.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38,26.5v3c0,0.276-0.224,0.5-0.5,0.5h-3c-0.276,0-0.5-0.224-0.5-0.5v-3c0-0.276,0.224-0.5,0.5-0.5h3C37.776,26,38,26.224,38,26.5z M30,26.5v3c0,0.276-0.224,0.5-0.5,0.5h-3c-0.276,0-0.5-0.224-0.5-0.5v-3c0-0.276,0.224-0.5,0.5-0.5h3C29.776,26,30,26.224,30,26.5z M22,26.5v3c0,0.276-0.224,0.5-0.5,0.5h-3c-0.276,0-0.5-0.224-0.5-0.5v-3c0-0.276,0.224-0.5,0.5-0.5h3C21.776,26,22,26.224,22,26.5z M14,26.5v3c0,0.276-0.224,0.5-0.5,0.5h-3c-0.276,0-0.5-0.224-0.5-0.5v-3c0-0.276,0.224-0.5,0.5-0.5h3C13.776,26,14,26.224,14,26.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30,33.5v3c0,0.276-0.224,0.5-0.5,0.5h-3c-0.276,0-0.5-0.224-0.5-0.5v-3c0-0.276,0.224-0.5,0.5-0.5h3C29.776,33,30,33.224,30,33.5z M22,33.5v3c0,0.276-0.224,0.5-0.5,0.5h-3c-0.276,0-0.5-0.224-0.5-0.5v-3c0-0.276,0.224-0.5,0.5-0.5h3C21.776,33,22,33.224,22,33.5z M14,33.5v3c0,0.276-0.224,0.5-0.5,0.5h-3c-0.276,0-0.5-0.224-0.5-0.5v-3c0-0.276,0.224-0.5,0.5-0.5h3C13.776,33,14,33.224,14,33.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#3ccbf4",
    d: "M35.5,11L35.5,11c-0.828,0-1.5-0.672-1.5-1.5v-4C34,4.672,34.672,4,35.5,4l0,0C36.328,4,37,4.672,37,5.5v4C37,10.328,36.328,11,35.5,11z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.52291d41.svg";
export { ForwardRef as ReactComponent };